module.exports = __webpack_public_path__ + "static/media/jakarta.deb59a19.jpg";